<template>
  <div class="view box grow">
    <page-headers :header="'My Account'" :breadcrumbs="breadcrumbs"></page-headers>
    <el-tabs v-model="activeTab" @tab-click="switchView">
      <el-tab-pane label="PERSONAL INFO" name="profile">
        <el-row :gutter="20" class="profile-row">
          <el-col :span="18">
            <el-row>
              <el-col :span="24">
                <div class="grid-title">Profile</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="profile-content">
                  Basic info, like your name and photo, that you use on Confluera.
                  Some info may be visible to other people in
                  <br />your organization.
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" class="avatar-row">
            <div class="avatar-container" @click="uploadProfileImg" v-if="!isProfileImgSet">
              <el-avatar :size="100" class="avatar-display">
                <span class="avatar-text">{{userProfile.firstname[0]}}{{userProfile.lastname[0]}}</span>
              </el-avatar>
              <div class="icon-container">
                <i class="material-icons c-icon avatar-icon">camera_alt</i>
              </div>
              <image-upload @save-image="uploadImage" ref="imageUploadRef"></image-upload>
            </div>
            <div v-else>
              <el-dropdown trigger="click" @command="handleCommand" :placement="'bottom-start'">
                <span class="el-dropdown-link">
                  <img
                    :src="imgDataUrl"
                    alt="altText"
                    width="96"
                    height="96"
                    class="avatar-profile"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="change">Change Profile Photo</el-dropdown-item>
                  <el-dropdown-item command="remove">Remove</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <image-upload
                v-if="imgChangeInProgress"
                @save-image="uploadImage"
                @cancel-image-upload="cancelChangeImage"
                ref="imageUploadRef"
              ></image-upload>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-title">About</div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-subtitle">Full Name</div>
              </el-col>
              <el-col :span="16">
                <div v-if="!editName">
                  <span>{{userProfile.firstname}} {{userProfile.lastname}}</span>
                </div>
                <div v-else class="edit-name">
                  <el-form
                    class="full-width"
                    :model="userInfo"
                    :rules="userInfoRules"
                    ref="userInfoForm"
                  >
                    <el-form-item class="display-inline-block edit-firstname" prop="firstname">
                      <el-input
                        :placeholder="userProfile.firstname"
                        v-model.trim="userInfo.firstname"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="display-inline-block edit-lastname" prop="lastname">
                      <el-input
                        :placeholder="userProfile.lastname"
                        v-model.trim="userInfo.lastname"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="edit-icon" v-if="!editName" @click="editName = true">
                  <i class="material-icons c-icon">create</i>
                </div>
                <div class="edit-icon" v-else>
                  <i class="far fa-window-close" @click="editName = false"></i>
                  <i
                    class="far fa-check-square"
                    @click="updateUser({'firstname': userInfo.firstname, 'lastname': userInfo.lastname})"
                  ></i>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-subtitle">Description</div>
              </el-col>
              <el-col :span="16" v-if="!editDescription">
                <div v-if="userProfile.description">{{userProfile.description}}</div>
                <div v-else>Description Here</div>
              </el-col>
              <el-col :span="16" v-else>
                <el-form
                  class="full-width"
                  :model="userInfo"
                  :rules="userInfoRules"
                  ref="userInfoForm"
                >
                  <el-form-item class="display-inline-block full-width" prop="description">
                    <el-input
                      :placeholder="userProfile.description"
                      v-model="userInfo.description"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="4">
                <div class="edit-icon" v-if="!editDescription">
                  <i class="material-icons c-icon" @click="editDescription = true">create</i>
                </div>
                <div class="edit-icon" v-else>
                  <i class="far fa-window-close" @click="editDescription = false"></i>
                  <i
                    class="far fa-check-square"
                    @click="userInfo.description? updateUser({'desc':userInfo.description}): editDescription = false"
                  ></i>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-subtitle">Your Organization</div>
              </el-col>
              <el-col :span="20">
                <div>{{networkInfo.customer_name}}</div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-subtitle">Job Title</div>
              </el-col>
              <el-col :span="20">
                <div>{{userProfile.roles[0].description}}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-title">Contact Info</div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-subtitle">Email Address</div>
              </el-col>
              <el-col :span="20">
                <div>{{userProfile.email}}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-title">Security</div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="20">
                <div>
                  <div class="grid-title">••••••••</div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="edit-icon" @click="editPasswordVisible = true">
                  <i class="material-icons c-icon">create</i>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
      </el-tab-pane>
      <el-tab-pane label="EMAIL NOTIFICATION PREFERENCE" name="email">
        <email-preference ref="emailPref"></email-preference>
      </el-tab-pane>
      <el-tab-pane label="SLACK NOTIFICATION PREFERENCE" name="slack-notification" v-if="$allow('users', 'write')">
        <slack-preference></slack-preference>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Change Password" :visible.sync="editPasswordVisible" width="45%">
      <span>
        <el-form
          :label-position="'left'"
          :model="userForm"
          :rules="userRules"
          label-width="110px"
          ref="changePasswordRef"
        >
          <el-form-item class="styled" label="Current" prop="currentPassword">
            <el-input v-model="userForm.currentPassword" class="password-value" show-password></el-input>
          </el-form-item>

          <el-form-item class="styled" label="New" prop="newPassword">
            <el-input
              class="button1"
              type="password"
              v-model="userForm.newPassword"
              autocomplete="off"
              show-password
            ></el-input>
            <el-progress
              class="password-strength-meter"
              :percentage="userForm.passwordStrengthScore"
              :color="userForm.passwordStrengthColor"
              :show-text="false"
            ></el-progress>
          </el-form-item>

          <el-form-item class="styled" label="Confirm New" prop="confirmPassword">
            <el-input v-model="userForm.confirmPassword" class="password-value" show-password></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <div v-if="userForm.error.length && !$_.isObject(userForm.error)" class="error_msg error">
          <label>{{userForm.error}}</label>
        </div>
        <el-button @click="editPasswordVisible = false">Cancel</el-button>
        <el-button type="primary" @click="resetPassword">Change Password</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageHeaders from "@/components/layout/PageHeaders.vue";
import EmailPreference from "@/views/admin/EmailPreference.vue";
import ImageUpload from "@/components/upload/ImageUpload.vue";
import SlackPreference from "@/views/admin/SlackPreference.vue";
import { PASSWORD_RESET } from "@/store/modules/auth/auth.type";
import {
  USER_PROFILE_IMG_GET,
  USER_PROFILE_IMG_SET,
  USER_PROFILE_IMG_REMOVE,
  USER_PROFILE,
  USER_UPDATE,
  USER_LIST_VOID
} from "@/store/modules/user/user.type";

import { PasswordScoreColorEnum } from "@/constants/password-score.constants";
import { validatePassword } from "@/utilities/user/validation";
import { getPasswordStrengthColor } from "@/utilities/passwordstrength.helper";

export default {
  name: "Account",
  data() {
    return {
      breadcrumbs: [{ title: "Account" }],
      activeView: "profile",
      dialogVisible: false,
      imgDataUrl: "",
      user_profile: "",
      isProfileImgSet: false,
      imgChangeInProgress: false,
      editName: false,
      editDescription: false,
      editPasswordVisible: false,
      isError: false,
      userInfo: {
        firstname: "",
        lastname: "",
        description: ""
      },
      userInfoRules: {
        firstname: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        description: [
          {
            max: 256,
            trigger: "blur"
          }
        ]
      },
      userForm: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordStrengthScore: 0,
        passwordStrengthColor: PasswordScoreColorEnum[0],
        error: ""
      },
      userRules: {
        currentPassword: [
          {
            required: true,
            min: 8,
            max: 64
          }
        ],
        newPassword: [
          {
            required: true,
            min: 8,
            max: 64,
            trigger: "change",
            validator: (rule, value, callback) => {
              let validPassword = validatePassword(value);
              let passwordStrengthMeta = getPasswordStrengthColor(
                validPassword.score
              );
              this.userForm.passwordStrengthScore =
                passwordStrengthMeta.percentage;
              this.userForm.passwordStrengthColor = passwordStrengthMeta.color;
              if (validPassword.score > 2) {
                if (this.userForm.confirmPassword !== "") {
                  this.$refs["changePasswordRef"].validateField(
                    "confirmPassword"
                  );
                }
                callback();
              } else {
                callback(validPassword.error);
              }
            }
          }
        ],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please input the password again"));
              } else if (value !== this.userForm.newPassword) {
                callback(new Error("Passwords did not match!"));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    activeTab: {
      get: function() {
        return this.$route.query.view;
      },
      set: function(val) {}
    },
    ...mapGetters(["userProfile", "networkInfo"])
  },
  methods: {
    switchView(tab, event) {
      // fetch relevent information for active view
      this.$router.replace({
        query: {
          view: tab.paneName
        }
      });
    },
    udpateNotificationPreferences() {
      this.$refs.emailPref.udpateEmailNotificationPreferences();
    },
    uploadProfileImg() {
      setTimeout(() => {
        if (this.$refs["imageUploadRef"]) {
          this.$refs["imageUploadRef"].showImageUpload();
        }
      }, 175);
    },
    cancelChangeImage() {
      this.imgChangeInProgress = false;
    },
    handleCommand(command) {
      if (command === "change") {
        this.imgChangeInProgress = true;
        this.$nextTick(() => {
          this.uploadProfileImg();
          this.$refs["imageUploadRef"].resetImageComponent();
        });
      } else {
        this.$store
          .dispatch(USER_PROFILE_IMG_REMOVE, {
            userId: this.userProfile.id
          })
          .then(
            data => {
              if (this.$refs["imageUploadRef"]) {
                this.$refs["imageUploadRef"].resetImageComponent();
              }
              this.isProfileImgSet = false;
            },
            errMsg => {
              console.log(errMsg);
            }
          );
      }
    },
    uploadImage(imageUrl) {
      if (!imageUrl) {
        return false;
      }
      this.$store
        .dispatch(USER_PROFILE_IMG_SET, {
          userId: this.userProfile.id,
          profileImg: imageUrl
        })
        .then(
          data => {
            this.imgDataUrl = imageUrl;
            this.isProfileImgSet = true;
            this.$refs["imageUploadRef"].resetImageComponent();
            this.$message({
              type: "success",
              message: "Profile image was successfully uploaded."
            });
            this.$store.dispatch(USER_LIST_VOID)
          },
          errMsg => {
            this.imgDataUrl = "";
            this.isProfileImgSet = false;
            this.$refs["imageUploadRef"].cancelImageUpload();
            this.$message({
              type: "error",
              message: "Error occurred during uploaded."
            });
          }
        );
      return true;
    },
    updateUser({ firstname, lastname, desc }) {
      this.$refs["userInfoForm"].validate(valid => {
        // let { firstname, lastname, description } = this;
        if (valid) {
          this.$store
            .dispatch(USER_UPDATE, {
              id: this.userProfile.id,
              firstname: firstname,
              lastname: lastname,
              description: desc
            })
            .then(
              () => {
                this.$store.dispatch(USER_PROFILE, {
                  email: this.userProfile.email
                });
                this.$refs["userInfoForm"].resetFields();
                this.editName = false;
                this.editDescription = false;
              },
              errMsg => {
                this.userFormError = errMsg;
                console.log("error occurred");
              }
            );
        } else {
          this.$set(
            this,
            "userFormError",
            "Please populate all requird fields."
          );
          return false;
        }
      });
    },
    resetPassword() {
      this.userForm.error = "";
      this.$refs["changePasswordRef"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch(PASSWORD_RESET, {
              currentPassword: this.userForm.currentPassword,
              newPassword: this.userForm.newPassword,
              confirmNewPassword: this.userForm.confirmPassword,
              email: this.userProfile.email
            })
            .then(
              data => {
                this.editPasswordVisible = false;
                this.$refs["changePasswordRef"].resetFields();
                this.$message({
                  type: "success",
                  message: "Your password was successfully updated."
                });
              },
              errMsg => {
                let err = errMsg.message ? errMsg.message : "Error occurred";
                this.userForm.error = err;
                console.log("error occurred");
              }
            );
        } else {
          this.userForm.error = "Please populate all required fields.";
          return false;
        }
      });
    }
  },
  components: {
    PageHeaders,
    EmailPreference,
    ImageUpload,
    SlackPreference
  },
  beforeMount() {
    this.$store
      .dispatch(USER_PROFILE_IMG_GET, {
        userId: this.userProfile.id
      })
      .then(
        data => {
          if (data["profileImg"]) {
            this.isProfileImgSet = true;
            this.imgDataUrl = data["profileImg"];
          }
        },
        errMsg => {
          console.log(errMsg);
        }
      );
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.view {
  height: 100%;

  .el-tabs {
    height: calc(100%-50px);
  }

  .icon-text-button {
    background: var(--main-blue);
    padding: 5px 10px;

    span {
      .c-icon {
        color: white;
        font-size: 1.2em;
        vertical-align: text-bottom;
        margin-right: 5px;
      }
      span {
        color: white;
        margin-bottom: 6px;
      }
    }
  }
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.table-toolbar {
  /* margin-top: 20px; */

  button {
    max-height: 36px;
  }
}

.el-select {
  width: 100%;
}

.el-select-dropdown__item.selected:after {
  right: 0px !important;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.vue-scroll {
  height: 75%;
  width: 100%;
}

.profile-row {
  margin-bottom: 32px !important;
}

.avatar-row {
  text-align: center;
}

.avatar-text {
  font-size: 32px;
  font-weight: bold;
}

.avatar-icon {
  color: white;
}

.el-tabs-header {
  margin: 0 0 24px;
}

.el-divider--horizontal {
  display: block;
  height: 1.5px;
  width: 100%;
  margin: 6px 0px 6px -50px;
}

.el-row {
  margin-bottom: 0px;
  vertical-align: middle;
  line-height: 40px;
  margin-right: -10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}

.grid-title {
  font-weight: bold;
  font-size: 14px;
  padding-bottom: 8px;
}

.grid-subtitle {
  font-size: 12px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.avatar-container {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}

.avatar-display {
  background-color: #77dab4;
  display: block;
}

.icon-container {
  position: absolute;
  bottom: 0;
  left: 9%;
  right: 0;
  height: 20%;
  display: flex;
  justify-content: center;
  background: #00000066;
}

.edit-icon {
  vertical-align: middle;
  line-height: 32px;
  cursor: pointer;
}

.profile-content {
  line-height: 20px;
}

.el-dropdown-menu__item {
  display: block;
}

.fa-window-close,
.fa-check-square {
  font-size: 32px;
  font-weight: 100;
  color: gray;
}

.edit-name {
  display: inline-flex;
  width: 100%;
}

.edit-firstname,
.edit-lastname {
  width: 45%;
}

.bottom-border {
  border-bottom: 0px solid black !important;
  margin-top: 16px !important;
}

.avatar-profile {
  border-radius: 50%;
}

.el-dialog__body {
  padding: 20px 20px;
}

.error_msg {
  color: red;
  padding-bottom: 20px;
}

.password-strength-meter {
  margin-top: 10px;
}

>>> .el-dropdown-menu .el-popper {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Account.vue